import { Component, OnInit } from '@angular/core';
import { FnModalService, FnTableConfig, FnTableMetaData, FnToasterService, FnUtilService, TABLE_ACTION_TYPE, TableAction } from 'foundation';
import { Subject } from 'rxjs';
import { PosHttpService } from '../../../services/pos.http.service';
import { EOProduct, EOStatusType, EOTeamGroup, EOTeam } from '../../../modal/entity.modal';


@Component({
  selector: 'app-status-type',
  templateUrl: './status-type.component.html',
  styleUrl: './status-type.component.scss'
})
export class StatusTypeComponent implements OnInit {
  constructor(private posHttpSvcs: PosHttpService, private fnModalSvcs: FnModalService, private fnutilservice: FnUtilService, private toaster: FnToasterService) {
    this.rowMetaArray;
  }

  ngOnInit(): void {
    this.loadEOProduct();
    this.loadEOTeamGroup();
    this.loadEOStatusType();
    this.loadTeamArray();
  }


  uiMap = {
    isDataLoaded: false,
  };
  showData = false;
  title = 'No Data to Display';
  objectHash: EOStatusType = {
    primaryKey: 0,
    cause: '',
    idenNo: '',
    uniqueKey: '',
    productName: '',
    isManualResolvable: false,
    resolution: '',
    escEmailSub: '',
    resetOffsetTimeInMin: 0,
    countForCriticality: 50,
    canDisable: true,
    isActive: true,
    isAutoEscalate: false,
    isSendToTeligram: false,
    defaultEscEmailID: '',
    typeIID: 'DEFAULT',
    toEscEmailID: '',
    telMeassageId: '',
    isHelpConfigured: false,
    isCustomeHelp: false,
    breachCount: 0,
    isCountBreach: false,
    isDualConditional: false,
    sevTelMessageId: '',
    isSendMail: false,
    teams:[],
  }

  config: FnTableConfig = {
    uniqueKey: 'primaryKey',
    defaultSortKey: 'primaryKey',
    tableAction: new Subject<TableAction>(),
  };

  rowMetaArray: FnTableMetaData[] = [
    {
      key: 'primaryKey',
      description: 'Primary Key',
      isHidden: true,
      isSortable: true,
      type: 'number',
    },
    {
      key: 'idenNo',
      description: 'idenNo',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'productName',
      description: 'Product Name',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'isManualResolvable',
      description: 'isManualResolvable',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'isActive',
      description: 'isActive',
      type: 'string',
      isSortable: false,
    },
    {
      key: 'canDisable',
      description: 'canDisable',
      type: 'string',
      isSortable: false,
    }

  ];
  productArray: EOProduct[] = [];
  statusTypeArray: EOStatusType[] = [];
  teamGroupArray: EOTeamGroup[] = [];
  selectedproduct: number = 0;
  teamsArray: EOTeam []=[];

  sevArray = [
    {
      "name": "Sev 3",
    },
    {
      "name": "Sev 2"
    },
    {
      "name": "Sev 1"
    }
  ];

  typeIIDArray = [
    {
      "name": "DEFAULT",
    },
    {
      "name": "RESET"
    },
    {
      "name": "GENERATE_ALERT"
    },
    {
      "name": "REMOVE_OLD_ALERT"
    },
    {
      "name": "IGNORE_GENERATE"
    },
    {
      "name": "EXCLUDE_RESOLVED"
    }
  ];

  updateRowAction = (tableRow: EOStatusType) => {
    this.objectHash = this.fnutilservice.copy(tableRow);
    this.productArray.forEach((productName => {
      if (productName.name == tableRow.productName) {
        this.objectHash.eoProduct = productName.primaryKey;
      }
    }
    ))
    this.teamGroupArray.forEach((teamGroupId => {
      if (teamGroupId.id == tableRow.teamGroupId) {
        this.objectHash.eoTeamGroup = teamGroupId.primaryKey;
      }
    }))
    this.objectHash.teams = this.fnutilservice.arrayFromArrayOfMap(this.objectHash.teams,'primaryKey');
    this.showData = true;
  };

  deleteRowAction(tableRow: EOStatusType) {
    const dialogRef = this.fnModalSvcs.openConfirmModal({
      isConformationMdl: true,
      content: 'Are you sure you want to delete EOStatusType ?',
      type: 'danger',
    });
    dialogRef.afterClosed().subscribe(doAction => {
      if (doAction) {
        this.posHttpSvcs.authDelete(`v1/ui/deleteEOStatusTypeData/${tableRow.primaryKey}`, tableRow.primaryKey).subscribe((resp) => {
          if (resp.isError) {
            this.toaster.error(' EOStatusType is not deleted ⚠️');
            return;
          } else {
            this.toaster.success("Deleted successfully");
            this.loadEOStatusType();
          }
        })
      }
    });
  }

loadTeamArray(){
    this.posHttpSvcs.authGet('v1/ui/getEOTeamArray', 'getEOTeamArray').subscribe((resp =>{
      if(resp.isError){
        this.toaster.error("EOTeamArray is not loaded");
      }
      this.teamsArray = resp.data;
    }))
  }

  loadEOStatusType() {
    this.posHttpSvcs.authGet('v1/ui/loadEOStatusType', 'loadEOStatusType').subscribe((resp: any) => {
      if (resp.isError) {
        this.toaster.error('Invalid loadEOStatusType credintials ⚠️');
        return;

      }
      this.statusTypeArray = resp.data;

      this.showData = false;
      this.refreshTableData();

      this.uiMap.isDataLoaded = true;

    })
  }

  loadEOProduct() {
    this.posHttpSvcs.authGet('v1/ui/loadProductName', 'loadProductName').subscribe((resp: any) => {
      if (resp.isError) {
        this.toaster.error('product name not loaded');
      }
      this.productArray = resp.data;
    })
  }

  loadEOTeamGroup() {
    this.posHttpSvcs.authGet('v1/ui/loadTeamGroupID', 'loadTeamGroupID').subscribe((resp: any) => {
      if (resp.isError) {
        this.toaster.error('Team name not loaded');
      }
      this.teamGroupArray = resp.data;
    })
  }

  openActionMdl() {
    this.resetObjectHash();
    this.showData = true;

  }
  close() {
    this.showData = false;
    this.refreshTableData();
    this.uiMap.isDataLoaded = true;
  }

  add() {
    if (this.fnutilservice.isEmptyObject(this.objectHash.idenNo)) {
      this.toaster.error('idenNo can not be null');
      throw new Error();
    }
    if (this.fnutilservice.isEmptyObject(this.objectHash.uniqueKey)) {
      this.toaster.error('UniqueKey field can not left blank and use ~ seperated');
      throw new Error();
    }
    if (this.fnutilservice.isEmptyObject(this.objectHash.eoProduct)) {
      this.toaster.error('Please select product');
      throw new Error();
    }
    if (this.fnutilservice.isEmptyObject(this.objectHash.teams)) {
      this.toaster.error('Please select Teams');
      throw new Error();
    }
    if (this.fnutilservice.isEmptyObject(this.objectHash.severity)) {
      this.toaster.error('Select severity');
      throw new Error();
    }
    if (this.fnutilservice.isEmptyObject(this.objectHash.defaultEscEmailID)) {
      this.toaster.error('defaultEscEmailID can not be null');
      throw new Error();
    }
    if (!this.validateEmail(this.objectHash.defaultEscEmailID)) {
      this.toaster.error('Invalid format in default EmailID');
      throw new Error('Invalid defaultEscEmailID');
    }
    this.posHttpSvcs.authPost('v1/ui/addEOStatusType', 'addEOStatusType', this.objectHash).subscribe((resp => {
      if (resp.isError) {
        this.toaster.error("addEOStatusType data not saved");
        return;
      } else {
        this.toaster.success("Action performed successfully");
        this.loadEOStatusType();
      }
    }))
  }

  emailRegex = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$");

  validateEmail(emailString: string): boolean {
    if (!emailString) {
      return false;
    }
    const emailArray = emailString.split(',');
    for (let i = 0; i < emailArray.length; i++) {
      const email = emailArray[i].trim();
      if (!this.emailRegex.test(email)) {
        return false;
      }
    }
    return true;
  }

  refreshTableData() {
    if (this.config.tableAction.closed) {
      this.config.tableAction = new Subject<TableAction>();
    }
    this.config.tableAction.next({
      data: this.statusTypeArray,
      action: TABLE_ACTION_TYPE.REFRESH,
    });
  }
  private resetObjectHash() {
    this.objectHash = this.initializeObjectHash();
  }
  private initializeObjectHash() {
    return {
      primaryKey: 0,
      cause: '',
      idenNo: '',
      uniqueKey: '',
      productName: '',
      isManualResolvable: false,
      resolution: '',
      escEmailSub: '',
      resetOffsetTimeInMin: 0,
      countForCriticality: 50,
      canDisable: true,
      isActive: true,
      isAutoEscalate: false,
      isSendToTeligram: false,
      defaultEscEmailID: '',
      typeIID: 'DEFAULT',
      toEscEmailID: '',
      telMeassageId: '',
      sevTelMessageId: '',
      isHelpConfigured: false,
      isCustomeHelp: false,
      breachCount: 0,
      isCountBreach: false,
      isDualConditional: false,
      isSendMail: false,
      teams: [],
    };
  }

}
